import { quickLinks, siteNav } from "@/mocks/site";

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-6 md:py-12">
        <div className="grid gap-8 md:grid-cols-12">
          {/* 品牌块 */}
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center bg-primary-500 font-display text-2xl font-black text-background-50">
                曝
              </span>
              <span className="leading-none">
                <span className="block font-display text-2xl font-black text-foreground-950">
                  曝瓜<span className="text-primary-600">网</span>
                </span>
                <span className="eyebrow mt-1 block text-[10px] text-foreground-500">用石锤说话 · 证据归档站</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-[13px] leading-6 text-foreground-600">
              曝瓜网专注重磅实锤与证据链整理，聊天记录、截图流出、录音曝光一手呈现。不空口爆料，用石锤说话，帮你快速看清事件真相。
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-2">
              <span className="flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-[11px] font-medium text-secondary-900">
                <i className="ri-shield-check-line text-primary-600" /> 内容均为静态演示素材
              </span>
              <span className="flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-[11px] font-medium text-secondary-900">
                <i className="ri-question-answer-line text-primary-600" /> 双向信息均做交叉核验
              </span>
            </div>
          </div>

          {/* 板块 */}
          <div className="grid grid-cols-2 gap-6 sm:grid-cols-3 md:col-span-7">
            <div>
              <h4 className="eyebrow mb-3 text-[11px] font-bold text-foreground-500">栏目</h4>
              <ul className="space-y-2.5">
                {siteNav.slice(0, 5).map((c) => (
                  <li key={c.key}>
                    <a href="#top" className="flex items-center gap-1.5 text-[13px] text-foreground-700 hover:text-primary-600">
                      <i className={`${c.icon} text-xs text-primary-500`} />
                      {c.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="eyebrow mb-3 text-[11px] font-bold text-foreground-500">站点</h4>
              <ul className="space-y-2.5">
                {quickLinks.map((q) => (
                  <li key={q.label}>
                    <a href="#" className="flex items-center gap-1.5 text-[13px] text-foreground-700 hover:text-primary-600">
                      <i className={`${q.icon} text-xs text-primary-500`} />
                      {q.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="eyebrow mb-3 text-[11px] font-bold text-foreground-500">版权与合规</h4>
              <ul className="space-y-2.5">
                {["侵权投诉", "转载与授权", "证据举报", "隐私说明"].map((t) => (
                  <li key={t}>
                    <a href="#" className="text-[13px] text-foreground-700 hover:text-primary-600">
                      {t}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* 免责声明 */}
        <div className="mt-8 rounded-lg border border-background-200 bg-background-50 p-4 text-[11px] leading-5 text-foreground-500">
          声明：本站为「曝瓜网」首页静态设计演示，页面中提及的机构、事件、聊天记录、截图与录音均为虚构演示内容，
          用于展示证据链整理与信息聚合的版式逻辑，不构成对任何真实主体的评价。内容证据展示强调"先取证、后下结论"。
        </div>

        <div className="mt-6 flex flex-col items-center justify-between gap-3 border-t border-dashed border-background-200 pt-5 text-[12px] text-foreground-500 sm:flex-row">
          <span>© 2026 曝瓜网 · 用石锤说话</span>
          <div className="flex flex-wrap items-center gap-4">
            <a href="#" className="hover:text-primary-600">
              <i className="ri-wechat-line" /> 公众号
            </a>
            <a href="#" className="hover:text-primary-600">
              <i className="ri-weibo-line" /> 微博
            </a>
            <a href="#" className="hover:text-primary-600">
              <i className="ri-telegram-line" /> 追更群
            </a>
            <a href="#" className="hover:text-primary-600">
              <i className="ri-mail-send-line" /> 投稿
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}